import { Typography } from '@recruit-robin/robin-theme/web-components';
import { Column, Row } from 'components/ui/atoms';
import { generateDtiAttribute } from 'helpers/helpers';
import { forwardRef } from 'react';
import { TooltipIcon } from 'shared/legacy/components/Tooltip';
import { useStyles } from './styles';
import { FieldLabelWrapperProps } from './types';

export const LABEL_FIELD_LABEL_WRAPPER = 'label-field-label-wrapper';

/**
 * @deprecated import `InputWrapper` from `@recruit-robin/robin-theme/web-components` instead
 */
export const FieldLabelWrapper = forwardRef(
  (
    { children, label, htmlFor, tooltipLabel, disabled = false, contained = false, className }: FieldLabelWrapperProps,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    const classes = useStyles();

    return (
      <Column ref={ref} css={classes.root} className={className} gap={6} contained={contained} inline>
        {(label || tooltipLabel) && (
          <Row gap={9} alignCenter spaceBetween>
            {label && (
              <label htmlFor={htmlFor} {...generateDtiAttribute('label')}>
                <Typography variant={(v) => v.supporting.label} color={(c) => c.neutral.variant[disabled ? 30 : 60]}>
                  {label}
                </Typography>
              </label>
            )}
            {tooltipLabel && <TooltipIcon title={tooltipLabel} disabled={disabled} />}
          </Row>
        )}
        {children}
      </Column>
    );
  },
);

export default FieldLabelWrapper;
